import React from 'react';
import Avatar from 'src/componentes/avatar';

const MentionDropdown = ({ 
  suggestions, 
  selectedIndex, 
  onSelect, 
  onSelectIndex
}) => {
  if (!suggestions?.length) return null;

  return (
    <div 
      className="mentions-dropdown"
      onMouseDown={(e) => {
        // Impedir que o click remova o foco do input
        e.preventDefault();
      }}
    >
      {suggestions.map((collaborator, index) => (
        <div
          key={collaborator.id}
          className={`mention-option ${index === selectedIndex ? 'selected' : ''}`}
          onClick={() => onSelect(collaborator)}
          onMouseEnter={() => onSelectIndex?.(index)}
        >
          <Avatar
            foto={collaborator.fotoArquivo}
            size={32}
            label={collaborator.nome}
          />
        </div>
      ))}
    </div>
  );
};

export default MentionDropdown;

